// extracted by mini-css-extract-plugin
module.exports = {"description":"SVPkNqUSb2NUNsNPbRjL3"};